<template>
    <div>
        <div class="title">{{$t('qr_scan')}}</div>
        <div class="container">
            <div class="row row-sezione">
                <div class="col-12" v-if="!this.table">
                    <p>Se ti trovi presso il ristorante, inquadra il QR Code che trovi sul tavolo per ordinare.</p>
                    <div class="px-5 py-2">
                        <qrcode-stream @init="onInit" @decode="onDecode">
                            <div class="spinner-border" role="status" v-if="this.loading">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <p v-if="this.qrcode_error">
                                Non è stato possibile connettersi alla fotocamera.
                            </p>
                        </qrcode-stream>
                    </div>
                </div>
                <div class="col-12" v-else>
                    <button class="btn btn-primary mx-auto" @click="this.onScanAgain" style="max-width:350px;">
                        {{$t('qr_new_scan')}}
                    </button>
                    <div class="mt-3">
                        <h6>{{$t('selected_table')}}:</h6>
                        <h5><b>{{this.table.nome}}</b></h5>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {QrcodeStream, QrcodeDropZone, QrcodeCapture} from 'vue-qrcode-reader';

import {decodeQrCode} from '../../../../api/restaurant/tableOrders';
import {mapState} from "vuex";

export default {
    name: "Lv1OrdinaTavolo",
    components: {QrcodeStream, QrcodeDropZone, QrcodeCapture},
    props: ['table'],
    data() {
        return {
            loading: false,
            qrcode_error: false,
            decoded_table: this.table
        };
    },
    computed: {
        ...mapState('localization', {
            language: 'language'
        }),
        ...mapState('restaurant', {
            restaurant_id: state => state.id,
            locale: state => state.locale
        })
    },
    methods: {
        onInit: async function (promise) {
            // show loading indicator
            this.loading = true;
            try {
                const {capabilities} = await promise;
                // successfully initialized
            } catch (error) {
                this.qrcode_error = true;

                /*if (error.name === 'NotAllowedError') {
                    // user denied camera access permisson
                } else if (error.name === 'NotFoundError') {
                    // no suitable camera device installed
                } else if (error.name === 'NotSupportedError') {
                    // page is not served over HTTPS (or localhost)
                } else if (error.name === 'NotReadableError') {
                    // maybe camera is already in use
                } else if (error.name === 'OverconstrainedError') {
                    // did you requested the front camera although there is none?
                } else if (error.name === 'StreamApiNotSupportedError') {
                    // browser seems to be lacking features
                }*/
            } finally {
                // hide loading indicator
                this.loading = false;
            }
        },
        onDecode: function (decodedString) {
            decodeQrCode(this.language, {
                id_ristorante: this.restaurant_id,
                id_locale: this.locale.id,
                identificativo: decodedString
            }).then(response => {
                this.decoded_table = response.tavolo;
                this.$emit('onQrCodeDecoded', this.decoded_table);
            }).catch(({messages}) => {
                alert(messages.join('\n'));
            });
        },
        onScanAgain: function () {
            this.decoded_table = null;
            this.$emit('onQrCodeScanAgain');
        }
    }
}
</script>
